module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/free-sg/mobile-a608656f0aaf3f193eb8b411c92190b6.png";